// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from "react";

const CONTACTS = [
  { id: 1, name: "Mike Thompson", company: "Canstorr Commodities", role: "VP Operations", email: "mike.t@canstorr.com", phone: "306-555-2001", lastContact: "2026-02-07", leadScore: 92, stage: "Negotiation", owner: "Tyson Becker", notes: "Finalizing partnership terms. Very engaged." },
  { id: 2, name: "Sarah Chen", company: "Western Mining Corp", role: "CTO", email: "sarah.chen@westernmining.com", phone: "403-555-2002", lastContact: "2026-02-06", leadScore: 85, stage: "Proposal", owner: "Lee Mehling", notes: "Interested in OreSync integration. Sent proposal Feb 4." },
  { id: 3, name: "Dave Richards", company: "Prairie Fleet Services", role: "Operations Manager", email: "dave.r@prairiefleet.com", phone: "306-555-2003", lastContact: "2026-02-05", leadScore: 78, stage: "Qualified", owner: "Lucas Mason", notes: "Wants fleet tracking for 45 vehicles. Needs demo." },
  { id: 4, name: "Jennifer Walsh", company: "Northern Health Authority", role: "Director of IT", email: "j.walsh@northernhealth.ca", phone: "250-555-2004", lastContact: "2026-02-08", leadScore: 88, stage: "Proposal", owner: "Des Bachynski", notes: "Beta testing VitaSync. Very positive feedback so far." },
  { id: 5, name: "Robert Kim", company: "AutoMax Dealers Group", role: "General Manager", email: "rkim@automaxdealers.com", phone: "604-555-2005", lastContact: "2026-01-28", leadScore: 65, stage: "Lead", owner: "Lucas Mason", notes: "Attended webinar. Interested in LotSync for 3 locations." },
  { id: 6, name: "Amanda Foster", company: "GreenLeaf Cannabis Co", role: "Compliance Director", email: "afoster@greenleafco.com", phone: "780-555-2006", lastContact: "2026-02-03", leadScore: 72, stage: "Qualified", owner: "Lucas Mason", notes: "Needs BudLedger for compliance tracking. Price sensitive." },
  { id: 7, name: "Tom Bradley", company: "Pacific Tire Warehouse", role: "Owner", email: "tom@pacifictire.com", phone: "604-555-2007", lastContact: "2026-02-01", leadScore: 81, stage: "Proposal", owner: "Lucas Mason", notes: "Sent TreadOps demo. Following up next week." },
  { id: 8, name: "Lisa Nguyen", company: "Apex Insurance Brokers", role: "Managing Partner", email: "lisa.n@apexinsurance.com", phone: "416-555-2008", lastContact: "2026-02-04", leadScore: 90, stage: "Negotiation", owner: "Lucas Mason", notes: "Wants PolicyForge for 12-person team. Closing soon." },
  { id: 9, name: "Mark Sullivan", company: "Sullivan Real Estate Group", role: "Broker", email: "mark@sullivanre.com", phone: "905-555-2009", lastContact: "2026-01-20", leadScore: 45, stage: "Closed-Lost", owner: "Lucas Mason", notes: "Went with competitor. Budget constraints cited." },
  { id: 10, name: "Priya Sharma", company: "BeautyBliss Salons", role: "Operations Director", email: "priya@beautybliss.com", phone: "604-555-2010", lastContact: "2026-02-06", leadScore: 76, stage: "Qualified", owner: "Lucas Mason", notes: "3 salon locations. Interested in GlowDesk scheduling features." },
  { id: 11, name: "James Whitfield", company: "SK Cattle Ranch", role: "Ranch Manager", email: "james@skcattle.com", phone: "306-555-2011", lastContact: "2026-02-02", leadScore: 70, stage: "Lead", owner: "Tyson Becker", notes: "500 head operation. Wants HerdLedger for herd management." },
  { id: 12, name: "Karen Phillips", company: "HealthFirst Clinics", role: "CEO", email: "karen@healthfirst.ca", phone: "306-555-2012", lastContact: "2026-01-30", leadScore: 95, stage: "Closed-Won", owner: "Des Bachynski", notes: "Signed 2-year contract for VitaSync. Onboarding in progress." },
];

const STAGES = ["All", "Lead", "Qualified", "Proposal", "Negotiation", "Closed-Won", "Closed-Lost"];

export default function ContactsPage() {
  const [contacts, setContacts] = useState(CONTACTS);
  const [search, setSearch] = useState("");
  const [stageFilter, setStageFilter] = useState("All");
  const [showAddModal, setShowAddModal] = useState(false);
  const [newContact, setNewContact] = useState({ name: "", company: "", role: "", email: "", phone: "", stage: "Lead" });
  const [expandedContact, setExpandedContact] = useState(null);

  const filtered = contacts.filter(c => {
    if (search && !c.name.toLowerCase().includes(search.toLowerCase()) && !c.company.toLowerCase().includes(search.toLowerCase())) return false;
    if (stageFilter !== "All" && c.stage !== stageFilter) return false;
    return true;
  });

  const hotLeads = contacts.filter(c => c.leadScore >= 80 && !c.stage.startsWith("Closed")).length;
  const thisMonthNew = contacts.filter(c => c.lastContact >= "2026-02-01").length;
  const wonCount = contacts.filter(c => c.stage === "Closed-Won").length;
  const lostCount = contacts.filter(c => c.stage === "Closed-Lost").length;
  const conversionRate = wonCount + lostCount > 0 ? Math.round(wonCount / (wonCount + lostCount) * 100) : 0;

  const stageColor = (stage) => {
    const colors = { Lead: "#64748b", Qualified: "#3b82f6", Proposal: "#eab308", Negotiation: "#f97316", "Closed-Won": "#10b981", "Closed-Lost": "#ef4444" };
    return colors[stage] || "#64748b";
  };

  const addContact = () => {
    if (!newContact.name) return;
    setContacts(prev => [...prev, { ...newContact, id: Date.now(), lastContact: "2026-02-09", leadScore: 50, owner: "Lucas Mason", notes: "" }]);
    setNewContact({ name: "", company: "", role: "", email: "", phone: "", stage: "Lead" });
    setShowAddModal(false);
  };

  return (
    <div>
      <div className="page-header">
        <div><h1>Contacts</h1><p>{contacts.length} contacts in CRM</p></div>
        <button className="btn btn-primary" onClick={() => setShowAddModal(true)}>+ Add Contact</button>
      </div>

      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Total Contacts</div><div className="stat-value">{contacts.length}</div></div>
        <div className="stat-card"><div className="stat-label">Hot Leads</div><div className="stat-value" style={{ color: "#f97316" }}>{hotLeads}</div><div style={{ fontSize: 12, color: "#64748b" }}>Score 80+</div></div>
        <div className="stat-card"><div className="stat-label">New This Month</div><div className="stat-value" style={{ color: "#10b981" }}>{thisMonthNew}</div></div>
        <div className="stat-card"><div className="stat-label">Conversion Rate</div><div className="stat-value" style={{ color: "#10b981" }}>{conversionRate}%</div><div style={{ fontSize: 12, color: "#64748b" }}>{wonCount}W / {lostCount}L</div></div>
      </div>

      {/* Filters */}
      <div className="card" style={{ display: "flex", gap: 12, alignItems: "center", padding: "12px 20px", flexWrap: "wrap" }}>
        <input className="input" value={search} onChange={e => setSearch(e.target.value)} placeholder="Search contacts or companies..." style={{ flex: 1, minWidth: 200 }} />
        <div style={{ display: "flex", gap: 6 }}>
          {STAGES.map(s => (
            <button key={s} className={"btn btn-sm " + (stageFilter === s ? "btn-primary" : "btn-outline")} onClick={() => setStageFilter(s)}>
              {s}
              {s !== "All" && <span style={{ marginLeft: 4, opacity: 0.7 }}>({contacts.filter(c => c.stage === s).length})</span>}
            </button>
          ))}
        </div>
      </div>

      {/* Contact List */}
      <div className="card" style={{ marginTop: 16 }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr>
              <th style={{ textAlign: "left", padding: "10px 12px", borderBottom: "2px solid #334155", color: "#94a3b8" }}>Name</th>
              <th style={{ textAlign: "left", padding: "10px 12px", borderBottom: "2px solid #334155", color: "#94a3b8" }}>Company</th>
              <th style={{ textAlign: "left", padding: "10px 12px", borderBottom: "2px solid #334155", color: "#94a3b8" }}>Stage</th>
              <th style={{ textAlign: "center", padding: "10px 12px", borderBottom: "2px solid #334155", color: "#94a3b8" }}>Score</th>
              <th style={{ textAlign: "left", padding: "10px 12px", borderBottom: "2px solid #334155", color: "#94a3b8" }}>Owner</th>
              <th style={{ textAlign: "left", padding: "10px 12px", borderBottom: "2px solid #334155", color: "#94a3b8" }}>Last Contact</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(contact => (
              <React.Fragment key={contact.id}>
                <tr style={{ cursor: "pointer", background: expandedContact === contact.id ? "#0f172a" : "transparent" }} onClick={() => setExpandedContact(expandedContact === contact.id ? null : contact.id)}>
                  <td style={{ padding: "10px 12px", borderBottom: "1px solid #1e293b" }}>
                    <div style={{ fontWeight: 600, color: "#e2e8f0" }}>{contact.name}</div>
                    <div style={{ fontSize: 11, color: "#64748b" }}>{contact.role}</div>
                  </td>
                  <td style={{ padding: "10px 12px", borderBottom: "1px solid #1e293b", color: "#e2e8f0" }}>{contact.company}</td>
                  <td style={{ padding: "10px 12px", borderBottom: "1px solid #1e293b" }}>
                    <span className="badge" style={{ background: stageColor(contact.stage) + "22", color: stageColor(contact.stage) }}>{contact.stage}</span>
                  </td>
                  <td style={{ padding: "10px 12px", borderBottom: "1px solid #1e293b", textAlign: "center" }}>
                    <span style={{ fontWeight: 700, color: contact.leadScore >= 80 ? "#10b981" : contact.leadScore >= 60 ? "#eab308" : "#64748b" }}>{contact.leadScore}</span>
                  </td>
                  <td style={{ padding: "10px 12px", borderBottom: "1px solid #1e293b", color: "#94a3b8" }}>{contact.owner}</td>
                  <td style={{ padding: "10px 12px", borderBottom: "1px solid #1e293b", color: "#94a3b8" }}>{contact.lastContact}</td>
                </tr>
                {expandedContact === contact.id && (
                  <tr>
                    <td colSpan={6} style={{ padding: "16px", background: "#0f172a", borderBottom: "1px solid #334155" }}>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 }}>
                        <div><div style={{ fontSize: 11, color: "#64748b" }}>Email</div><div style={{ fontSize: 13, color: "#e2e8f0" }}>{contact.email}</div></div>
                        <div><div style={{ fontSize: 11, color: "#64748b" }}>Phone</div><div style={{ fontSize: 13, color: "#e2e8f0" }}>{contact.phone}</div></div>
                        <div><div style={{ fontSize: 11, color: "#64748b" }}>Lead Score</div><div style={{ fontSize: 13, color: "#e2e8f0" }}>{contact.leadScore}/100</div></div>
                      </div>
                      <div style={{ marginTop: 12 }}>
                        <div style={{ fontSize: 11, color: "#64748b" }}>Notes</div>
                        <div style={{ fontSize: 13, color: "#e2e8f0", marginTop: 4 }}>{contact.notes}</div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {/* Stage Funnel */}
      <div className="card" style={{ marginTop: 16 }}>
        <div className="card-header"><h3>Pipeline Funnel</h3></div>
        <div className="chart-bar-container">
          {STAGES.slice(1).map(stage => {
            const count = contacts.filter(c => c.stage === stage).length;
            return (
              <div key={stage} className="chart-bar-row">
                <span className="chart-bar-label" style={{ width: 120 }}>{stage}</span>
                <div className="chart-bar-track">
                  <div className="chart-bar-fill" style={{ width: (count / contacts.length * 100) + "%", background: stageColor(stage) }}>{count} contacts</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Add Contact Modal */}
      {showAddModal && (
        <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Add New Contact</h2>
              <button className="modal-close" onClick={() => setShowAddModal(false)}>X</button>
            </div>
            <div className="modal-body">
              <div className="form-field"><label>Full Name</label><input className="input" value={newContact.name} onChange={e => setNewContact({ ...newContact, name: e.target.value })} placeholder="Contact name" /></div>
              <div className="form-row">
                <div className="form-field"><label>Company</label><input className="input" value={newContact.company} onChange={e => setNewContact({ ...newContact, company: e.target.value })} placeholder="Company" /></div>
                <div className="form-field"><label>Role</label><input className="input" value={newContact.role} onChange={e => setNewContact({ ...newContact, role: e.target.value })} placeholder="Job title" /></div>
              </div>
              <div className="form-row">
                <div className="form-field"><label>Email</label><input className="input" value={newContact.email} onChange={e => setNewContact({ ...newContact, email: e.target.value })} placeholder="Email" /></div>
                <div className="form-field"><label>Phone</label><input className="input" value={newContact.phone} onChange={e => setNewContact({ ...newContact, phone: e.target.value })} placeholder="Phone" /></div>
              </div>
              <div className="form-field">
                <label>Stage</label>
                <select value={newContact.stage} onChange={e => setNewContact({ ...newContact, stage: e.target.value })} style={{ padding: "8px 12px", background: "#0f172a", border: "1px solid #334155", borderRadius: 6, color: "#e2e8f0", width: "100%" }}>
                  {STAGES.slice(1).map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline" onClick={() => setShowAddModal(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={addContact}>Add Contact</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
